module.exports = "https://cdn.littlereply.com/tt/resource/icon_followers_white.9ff387d0cadf3d4fa517afb64a023a05.png";